<template>
  <section>
    <div class="row" :class="[{'toogle-el': !toogleRealtime}]">

      <div class="col-md-12 tab-one-wrapper">
        <form id="filter-charts">
            <div class="row col-10">
              <label for="inputSelectQueue">Filtro de Filas para os Gráficos</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="selectType"><i class="fas fa-chart-bar"></i></span>
                </div>
                <select class="form-control" name="selectedQueue" id="inputSelectQueue" v-model="chartFilter" required aria-label="Tipo" aria-describedby="selectType">
                  <option value="*" selected>Todos</option>
                </select>
              </div>
          </div>
        </form>

        <div class="wrapper-charts">
          <PizzaChartAnswered :filter="chartFilter"></PizzaChartAnswered>
          <PizzaChartAbandoned :filter="chartFilter"></PizzaChartAbandoned>
        </div>
      </div>
      
      <div class="col-md-12 tab-two-wrapper">
        <div class="wrapper-group">
          <AverageTimeCalls type="serviceTime" :filter="chartFilter"></AverageTimeCalls>
          <AverageTimeCalls type="waitingTime" :filter="chartFilter"></AverageTimeCalls>
        </div>

        <div>
          <OperatorProductivityChart :filter="chartFilter"></OperatorProductivityChart>
          <MixedChart :filter="chartFilter"></MixedChart>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" :class="[{'toogle-el': toogleRealtime}]">
      <div id="table-dash-hour-hour" class="col-md-12">
        <form id="filter">
          <div class="row">
            <div class="col-4">
              <label for="inputSelectType">Filas</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="selectType"><i class="fas fa-chart-bar"></i></span>
                </div>
                <select class="form-control" name="selectedLog" id="inputSelectType" required aria-label="Tipo" aria-describedby="selectType">
                  <option value="*" selected>Todos</option>
                </select>
                <div class="input-group-prepend">
                  <button type="submit" id="btnSubmit" class="btn btn-primary"><i class="fa fa-search fa-fw"></i></button>
                </div>
                <div class="input-group-prepend">
                  <button type="reset" id="btnReset" class="btn btn-secondary"><i class="fas fa-times-circle fa-fw"></i></button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import AverageTimeCalls from "../charts/AverageTimeCalls.vue";
import OperatorProductivityChart from "../charts/OperatorProductivityChart.vue";
import MixedChart from "../charts/MixedChart.vue";
import PizzaChartAnswered from "../charts/PizzaChartAnswered.vue";
import PizzaChartAbandoned from "../charts/PizzaChartAbandoned.vue";

export default {
  name: "DashboardApp",
  components: {
    AverageTimeCalls,
    OperatorProductivityChart,
    MixedChart,
    PizzaChartAnswered,
    PizzaChartAbandoned
  },
  data() {
    return {
      toogleRealtime: false,
      intervalId: "",
      cl: "toogle",
      chartFilter: "*"
    };
  },
  created() {
    this.toogleRealtime = true;
  },
  methods: {
    updateCharts() {
      this.chartFilter
    }
  },
};
</script>

<style scoped>
.tab-one-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.wrapper-charts {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

#filter-charts {
  margin-left: 2%;
}

.tab-two-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.sub-group {
  width: 45%;
}

.wrapper-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.toogle-el {
  display: none;
}
</style>